<script>import { reducedMotion } from "../../stores/reduced-motion";
import { circIn, circInOut } from "svelte/easing";
import { tweened } from "svelte/motion";
import { getToasterContext } from "./context";
export let toast = void 0;
const position = getToasterContext()?.position;
function bounds(value, [outMin, outMax], [inMin, inMax] = [0, 1]) {
  return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
function animate(node, params) {
  const style = getComputedStyle(node);
  const transform = style.transform === "none" ? "" : style.transform;
  let transformOrigin = "center";
  if (params.position) {
    transformOrigin = params.position.startsWith("bottom") ? "bottom" : "top";
  }
  return {
    duration: params.direction === "in" ? 300 : 200,
    easing: params.direction === "in" ? circInOut : circIn,
    css: (t) => {
      return $reducedMotion ? `opacity: ${t}` : `
          ${params.direction === "out" ? "z-index: 1;" : ""}
          transform-origin: ${transformOrigin};
          transform: ${transform} scale(${bounds(t, [0.6, 1])});
          opacity: ${t}
        `;
    }
  };
}
let scale = tweened(1, { duration: 100 });
let lastreoccurredAt = void 0;
$:
  if (toast?.reoccurredAt !== lastreoccurredAt) {
    lastreoccurredAt = toast?.reoccurredAt;
    $scale = 1.05;
    setTimeout(() => scale.set(1, { duration: 600 }), 200);
  }
</script>

<div
  in:animate={{ direction: 'in', position }}
  out:animate={{ direction: 'out', position }}
  style="transform: scale({$scale})"
>
  <slot />
</div>
